import React from 'react'
import { Dropdown as DropDownBs } from 'react-bootstrap';
import { Link } from "react-router-dom";

const Dropdown = ({ title, icon, dropDownList, type = "", className = "" }) => {
  return (
    <div className={className}> 
      <DropDownBs drop="right" flip="true" className="Dropdown">
        <DropDownBs.Toggle id="dropdown-basic" className={(type && "Arrow ") + className}  >
          {icon}
          <span className="Dropdown_Label">{title}</span>
        </DropDownBs.Toggle>
        <DropDownBs.Menu className="Dropdown_Menu">
          {
            dropDownList.map(item => {
              const { component } = item;

              return (
                <div key={item.name}>
                  {
                    item.component ? 
                    (
                      <DropDownBs.Item key={item.name}>
                        <span className="Dropdown_Component">{component}</span>
                      </DropDownBs.Item>
                    ) :
                    (
                      <DropDownBs.Item href={item.link} key={item.name}>
                        <Link to={item.link} className="Dropdown_Item">
                          <span className="mx-2">{item.name}</span>
                        </Link>
                      </DropDownBs.Item>
                    )
                  }
                </div>
              )
            })
          }
        </DropDownBs.Menu>
      </DropDownBs>
    </div>
  )
}

export default Dropdown;